<script>
export default {
  name: 'GlitchText',

  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <div
    class="c-glitch-text"
    :data-text="text"
  >
    {{ text }}
  </div>
</template>

<style lang="scss">

.c-glitch-text {
  @include relative;
  animation: glitch 5s 5s infinite;

  &:before,
  &:after {
    content: attr(data-text);
    position: absolute;
    top: 0;
    overflow: hidden;
    background-color: translucent($black, 0.1);
  }

  &:before {
    left: -0.1em;
    text-shadow: -0.25em 0 translucent($purple, 0.25);
    animation: noise-1 1.5s linear infinite alternate-reverse, glitch 5s 5.05s infinite;
  }

  &:after {
    left: 0.1em;
    text-shadow: -0.25em 0 translucent($green, 0.25);
    animation: noise-2 1.5s linear infinite alternate-reverse, glitch 5s 5s infinite;
  }

}

// Animations

// @keyframes fudge {
//   from {
//     transform: translate(0, 0);
//   }
//   to {
//     transform: translate(0, 2%);
//   }
// }

@keyframes noise-1 {
  $steps: 30;
  @for $i from 1 through $steps {
    #{percentage($i*(1/$steps))} {
      $top: random(100);
      $bottom: random(101 - $top);
      clip-path: inset(#{$top}px 0 #{$bottom}px 0);
    }
  }
}

@keyframes noise-2 {
  $steps: 30;
  @for $i from 0 through $steps {
    #{percentage($i*(1/$steps))} {
      $top: random(100);
      $bottom: random(101 - $top);
      clip-path: inset(#{$top}px 0 #{$bottom}px 0);
    }
  }
}

@keyframes glitch {
  1%{
    transform: rotateX(10deg) skewX(90deg);
  }
  2%{
    transform: rotateX(0deg) skewX(0deg);
  }
}

@keyframes glitch-2 {
  1%{
    transform: rotateX(10deg) skewX(70deg);
  }
  2%{
    transform: rotateX(0deg) skewX(0deg);
  }
}

</style>
